import { render, staticRenderFns } from "./LLamadas.vue?vue&type=template&id=190b0fca&"
import script from "../js/LLamadas.vue?vue&type=script&lang=js&"
export * from "../js/LLamadas.vue?vue&type=script&lang=js&"
import style0 from "./LLamadas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports